import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  profileAndSettings: false,
  filingScreens: false,
  uploadingData: false,
  taxCodes: false,
};

export default reducerFactory(initialState, {
  [types.SET_ACTIVE_TOUR]: (state, { payload }) => ({
    ...state,
    [payload.tour]: payload.isActive,
  }),
  [types.RESET_ALL_ACTIVE_TOURS]: () => ({
    ...initialState,
  }),
});
